import colors from "../colors";

const cardHeader = {
  styleOverrides: {
    root: {
      background: colors.background.bgPrimary,
    },
  },
};

export default cardHeader;
